import { ArrowUpRight } from "lucide-react";
import { Pic } from "./Pic";
import { MODELS, SIZES, askModel } from "./Models";

// Turnkey house models inside the "Case in legno" product gallery: size, m², starting price, quick quote.
export const GalleryModels = ({ t, onClose }) => {
  const ask = (m, name) => {
    const msg = t("models.msgSize", "Sono interessato alla {name} (a partire da {price}.000 €).").replace("{name}", name).replace("{price}", m.price);
    onClose();
    setTimeout(() => askModel(m, msg), 300);
  };
  return (
    <section className="mt-8 border-t border-white/10 pt-6" data-testid="gallery-models">
      <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-[#D98A52]">{t("gal.models", "Modelli chiavi in mano")}</h3>
      <ul className="mt-4 grid gap-3 sm:grid-cols-2">
        {SIZES.flatMap((s) => s.models.map((id, n) => {
          const m = MODELS.find((x) => x.id === id);
          const name = `${t("models.casa", "Casa")} ${s.id} · ${n + 1}`;
          return (
            <li key={id}>
              <button type="button" onClick={() => ask(m, name)} className="group flex w-full items-center gap-4 border border-white/10 bg-[#1B1816] p-3 text-left transition-[border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-[#D98A52]" data-testid={`gallery-model-${id}`}>
                <span className="h-16 w-24 shrink-0 overflow-hidden">
                  <Pic src={m.img} alt={`${t("models.alt", "Casa in legno")} ${name}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block font-mono text-xs uppercase tracking-[0.18em] text-[#A39E93]">{name} · {t(`models.size.${s.id}.tag`, s.tag)}</span>
                  <span className="mt-1 block font-display text-lg font-bold text-[#F7F5F0]" data-testid={`gallery-model-sqm-${id}`}>{m.sqm ? `${m.sqm} m²` : "[00] m²"}</span>
                  <span className="block text-sm text-[#CFC8BC]">{t("models.from", "A partire da")} € {m.price}.000</span>
                </span>
                <ArrowUpRight className="h-5 w-5 shrink-0 text-[#D98A52] transition-transform duration-300 group-hover:rotate-45" aria-hidden="true" />
              </button>
            </li>
          );
        }))}
      </ul>
      <p className="mt-3 text-xs text-[#A39E93]">{t("gal.modelsNote", "Tocca un modello per richiedere il preventivo: ogni casa si personalizza.")}</p>
    </section>
  );
};
